var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4 2.1C21.6 2.2 21.8 2.4 21.9 2.6C22 2.7 22 2.9 22 3V9C22 9.6 21.6 10 21 10C20.4 10 20 9.6 20 9V5.4L10.7 14.7C10.5 14.9 10.3 15 10 15C9.7 15 9.5 14.9 9.3 14.7C8.9 14.3 8.9 13.7 9.3 13.3L18.6 4H15C14.4 4 14 3.6 14 3C14 2.4 14.4 2 15 2H21C21.1 2 21.3 2 21.4 2.1ZM19 19V13C19 12.4 18.6 12 18 12C17.4 12 17 12.4 17 13V19C17 19.6 16.6 20 16 20H5C4.4 20 4 19.6 4 19V8C4 7.4 4.4 7 5 7H11C11.6 7 12 6.6 12 6C12 5.4 11.6 5 11 5H5C3.3 5 2 6.3 2 8V19C2 20.7 3.3 22 5 22H16C17.7 22 19 20.7 19 19Z",
    fill: "#3876BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7953_50694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4 2.1C21.6 2.2 21.8 2.4 21.9 2.6C22 2.7 22 2.9 22 3V9C22 9.6 21.6 10 21 10C20.4 10 20 9.6 20 9V5.4L10.7 14.7C10.5 14.9 10.3 15 10 15C9.7 15 9.5 14.9 9.3 14.7C8.9 14.3 8.9 13.7 9.3 13.3L18.6 4H15C14.4 4 14 3.6 14 3C14 2.4 14.4 2 15 2H21C21.1 2 21.3 2 21.4 2.1ZM19 19V13C19 12.4 18.6 12 18 12C17.4 12 17 12.4 17 13V19C17 19.6 16.6 20 16 20H5C4.4 20 4 19.6 4 19V8C4 7.4 4.4 7 5 7H11C11.6 7 12 6.6 12 6C12 5.4 11.6 5 11 5H5C3.3 5 2 6.3 2 8V19C2 20.7 3.3 22 5 22H16C17.7 22 19 20.7 19 19Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7953_50694)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24H0V0Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/RedirectIcon.c7c3f0427d860615e5ec41f180f27f2e.svg";
export { ForwardRef as ReactComponent };